module.exports = __webpack_public_path__ + "img/268f4d4.png";